// TSS vite/06 — env-driven config. Throws at boot if required vars are missing.

const required = ['VITE_SITE_URL', 'VITE_CONTACT_EMAIL'];
const missing = required.filter(k => !import.meta.env[k]);
if (missing.length) {
    throw new Error(`[boot] missing env: ${missing.join(', ')}`);
}

export const site = {
    url: import.meta.env.VITE_SITE_URL,
    domain: new URL(import.meta.env.VITE_SITE_URL).host,
    contactEmail: import.meta.env.VITE_CONTACT_EMAIL,
};

export const meta = {
    projectName: import.meta.env.VITE_PROJECT_NAME || 'Total Medios',
};
